// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".other-products[data-v-3a839bdc]{background-color:var(--white);border:1px solid var(--border-color)}.other-products__text[data-v-3a839bdc]{font-weight:500;margin-bottom:10px}.other-products--small-button[data-v-3a839bdc]{opacity:.5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
